import { render, staticRenderFns } from "./BrandingSection.vue?vue&type=template&id=02a17ff3"
import script from "./BrandingSection.vue?vue&type=script&lang=js"
export * from "./BrandingSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports